import { useProductData } from 'hooks/api/use-product-data';

import { getDaysUntilMigration, getTextAppProduct } from './helpers';

export function useMigrationDaysLeft(): number {
  const { installedProducts } = useProductData();
  const createdAt = getTextAppProduct(installedProducts)?.created_at;

  return createdAt ? getDaysUntilMigration(createdAt) : 0;
}
